module.exports = __webpack_public_path__ + "img/10_50.a8dfed94.png";